import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { AfterContentInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { NEVER, forkJoin } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { AuthPage } from 'src/app/models/auth/auth-page.model';
import { Document, DocumentUpdate, JobDocument } from 'src/app/models/document.model';
import { Item } from 'src/app/models/item.model';
import { DocumentsService } from 'src/app/services/sections/documents/documents.service';
import { JobService } from 'src/app/services/sections/job/job.service';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { GlobalUtilsService } from 'src/app/services/ui/global-utils.service';
import { DocViewerDocumentDetails } from '../document-viewer/document-viewer.component';
import { GenericModalComponent } from '../generic-modal/generic-modal.component';
import { NavigationActionButton } from '../navigation-bar/models/navigation-action-button.model';
import moment from 'moment';
import { AuthService } from 'src/app/services/auth.service';
import { UserAuthService } from 'src/app/services/user-auth.service';
import { AddClassificationDocumentType, AddClassificationJob, AddJobDocument, JobBinder, ManagedDocuments, ManagedJobDocument } from 'src/app/services/ui/models/managed-documents.model';
import { DomSanitizer } from '@angular/platform-browser';
import { DocumentConclusionOption } from 'src/app/models/document-conclusion-group.model';
import { LookupService } from 'src/app/services/lookup.service';
import { ToastService } from 'src/app/services/ui/toast.service';
import { ToastType } from '../toast/models/toast-type.enum';
import { cloneDeep, unionBy, unionWith, orderBy, groupBy } from 'lodash-es';
import { MatTab, MatTabChangeEvent } from '@angular/material/tabs';
import { DocumentFilterType } from 'src/app/models/enum/document-filter-type.enum';
import { DocumentThreadService } from 'src/app/services/document-thread.service';
import { DocumentThread, NotifyUser } from 'src/app/models/document-thread.model';
import { TokenHelper } from 'src/app/services/helpers/token.helper';
import { SiteNote } from 'src/app/models/site-notes/site-note.model';
import { SiteService } from 'src/app/services/site.service';
import { AccountSiteInfo } from 'src/app/models/user-account-info.model';
import { saveAs } from 'file-saver-es';
import { AiDocumentInfo } from 'src/app/models/ai-doc-info';
import { ThreadType } from 'src/app/models/enum/thread-type.enum';
import { MatSelectChange } from '@angular/material/select';
import { MatTableDataSource } from '@angular/material/table';
@Component({
	selector: 'document-view-page',
	templateUrl: './document-view-page.component.html',
	styleUrls: ['./document-view-page.component.scss', '../stylesheets/job-actions.scss', '../stylesheets/job-main.scss', '../stylesheets/job-inputs.scss']
})
export class DocumentViewPageComponent implements OnInit, OnDestroy, AfterContentInit {
	@ViewChild('manageDocumentModal') public manageDocumentModal: GenericModalComponent;
	@ViewChild('sidenav') sidenav: MatSidenav;
	@ViewChild('threadSidenav') threadSidenav: MatSidenav;
	@ViewChild('threadTab') threadTab: MatTab;
	@ViewChild('confirmationModal') deleteConfirmationModal: GenericModalComponent;

	public readonly moment = moment;

	public navigationBarActions: Map<string, NavigationActionButton>;

	public isDataLoading: boolean;
	public documentDetails: DocViewerDocumentDetails;
	public documentId: number;
	public oid: string;
	public isThumbnail: boolean;
	public jobId: number;
	public isLoading: boolean;
	public jobDocumentFormGroup: FormGroup;
	public additionalDocumentsForm: FormGroup;
	public filterDocumentsForm: FormGroup;

	public addClassificationForm: FormGroup;
	public addClassificationSites: AccountSiteInfo[] = [];
	public addClassificationSiteAssets: Item<number, string>[] = [];
	public classificationDocumentTypes: AddClassificationDocumentType[] = [];
	public addClassificationJob: AddClassificationJob;
	public isOnAddClassification = false;
	public jobDocumentToDelete: ManagedJobDocument;
	public addClassificationDocumentClassAndTypeMappingId: number;
	public isManagedJobDocumentReviewRequired: boolean;


	public threadForm: FormGroup;
	public completedFollowUpForm: FormGroup;
	public threadSearchForm: FormGroup;
	public threadFilterForm: FormGroup;
	public supportOutForm: FormGroup;

	public additionalDocumentsCopy = [];
	public documentConclusionOptions: DocumentConclusionOption[] = [];
	public documentConclusionOptionSameGroupId: number = null;
	public isExtended: boolean;
	public jobDocuments: JobDocument[] = [];

	public documentTypes: Item<number, string>[] = [];
	public documentUpdate: DocumentUpdate;
	public selectedJobDocument: ManagedJobDocument = null;

	public documentThreads: DocumentThread[] = null;
	public documentThreadsCopy: DocumentThread[] = null;
	public selectedThread: DocumentThread = null;
	public notifyUsers: NotifyUser[] = [];
	public jobDocNotifyUsers: NotifyUser[] = [];
	public accountRouteUrls: Map<AuthPage, string>;
	public jobDocument: JobDocument;
	public isMobileDevice: boolean;
	public filterValues: Item<number, string>[] = [{ id: 1, name: 'All Records' }, { id: 2, name: 'Completed' }, { id: 3, name: 'Open' }];
	public threadFilterValues: Item<number, string>[] = [{ id: 0, name: 'All' }, { id: 1, name: 'Note' }, { id: 2, name: 'Follow Up' }, { id: 3, name: 'Support Request In' }, { id: 5, name: 'Support Out Request' }];

	public managedJobDocuments: ManagedDocuments;
	public permissionDenied = false;
	public isGuest: boolean = false;
	public hasLoadingError = false;
	public isEmailSummaryTab = false;

	public isUnsavedWork = false;
	public showWarningMessage = false;
	public isSidenavOpen = false;

	public selectedTabIndex = 0;

	public isOnCompleteFollowUp = false;
	public isAIDocument: boolean;

	public today = new Date();

	public downloadButton: HTMLButtonElement;
	public disableDownloadDocButton: boolean;
	public customButtons: any[] = [];
	public docViewerHeaderReady: boolean;
	public aiDocInfo: AiDocumentInfo = null;
	public readonly self = this;

	public threadTypes: Item<number, string>[] = [];
	public threadTypeEnum = ThreadType;
	
	displayedColumns: string[] = ['thread-type', 'isCompleted', 'description', 'follow-up-by', 'requested-by', 'completed-by'];

	constructor(
		private documentsService: DocumentsService,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private jobService: JobService,
		private authService: AuthService,
		private userAuthService: UserAuthService,
		private lookupService: LookupService,
		private documentThreadService: DocumentThreadService,
		private siteService: SiteService,
		private cdRef: ChangeDetectorRef
	) { }

	ngOnInit(): void {
		GlobalSettingsService.isGlobalLoaderLoading = false;
		GlobalSettingsService.isSecondaryLoaderLoading = false;

		this.navigationBarActions = GlobalSettingsService.navigationBarActions;
		GlobalSettingsService.navigationBarActions = new Map<string, NavigationActionButton>();

		this.isMobileDevice = GlobalUtilsService.isMobileDevice;


		this.documentId = parseInt(this.activatedRoute.snapshot.paramMap.get('documentId'), 10);
		this.oid = this.activatedRoute.snapshot.paramMap.get('oid');
		this.isDocumentAI();

		this.initDocumentsForm();
		this.isThumbnail = this.router.url.endsWith(`${this.documentId}/th`);
		this.getDocument(this.isThumbnail);
		
		this.initThreadForm();
		this.initThreadSearchForm();
		this.initCompletionFollowUpForm();

		this.initAddClassificationForm();

		this.initSupportOutForm();

		this.filterDocumentsForm?.get('name')?.valueChanges.subscribe(name => {
			name = name?.length !== 0 ? name : null;
			this.additionalDocs.controls = this.additionalDocumentsCopy;
			if (name !== null) {
				this.searchFilter(name, DocumentFilterType.Name);
				this.searchFilter(this.filterDocumentsForm.get('documentTypeId')?.value, DocumentFilterType.DocumentType);
				this.searchFilter((this.filterDocumentsForm.get('effectiveDate')?.value)?.format('MM/DD/YYYY'), DocumentFilterType.EffectiveDate);
			} else {
				this.searchFilter(this.filterDocumentsForm.get('documentTypeId')?.value, DocumentFilterType.DocumentType);
				this.searchFilter((this.filterDocumentsForm.get('effectiveDate')?.value)?.format('MM/DD/YYYY'), DocumentFilterType.EffectiveDate);
			}
		});

		this.filterDocumentsForm?.get('documentTypeId')?.valueChanges.subscribe(docType => {
			this.additionalDocs.controls = this.additionalDocumentsCopy;
			if (docType !== null && docType !== 0) {
				this.searchFilter(docType, DocumentFilterType.DocumentType);
				this.searchFilter((this.filterDocumentsForm.get('effectiveDate')?.value)?.format('MM/DD/YYYY'), DocumentFilterType.EffectiveDate);
				this.searchFilter(this.filterDocumentsForm.get('name')?.value?.toLowerCase(), DocumentFilterType.Name);
			} else {
				this.searchFilter((this.filterDocumentsForm.get('effectiveDate')?.value)?.format('MM/DD/YYYY'), DocumentFilterType.EffectiveDate);
				this.searchFilter(this.filterDocumentsForm.get('name')?.value?.toLowerCase(), DocumentFilterType.Name);
			}
		});

		this.filterDocumentsForm?.get('effectiveDate')?.valueChanges.subscribe(date => {
			this.additionalDocs.controls = this.additionalDocumentsCopy;
			if (date !== null) {
				this.searchFilter(date, DocumentFilterType.EffectiveDate);
				this.searchFilter(this.filterDocumentsForm.get('name')?.value?.toLowerCase(), DocumentFilterType.Name);
				this.searchFilter(this.filterDocumentsForm.get('documentTypeId')?.value, DocumentFilterType.DocumentType);
			} else {
				this.searchFilter(this.filterDocumentsForm.get('name')?.value?.toLowerCase(), DocumentFilterType.Name);
				this.searchFilter(this.filterDocumentsForm.get('documentTypeId')?.value, DocumentFilterType.DocumentType);
			}
		});

		this.threadSearchForm?.get('filterValues').valueChanges.subscribe(value => {
			this.documentThreads = this.documentThreadsCopy;

			const threadTypeId = this.threadFilterForm?.get('threadFilterValue').value;
			this.filterThreads(value, this.documentThreads);
			this.filterByThreadType(threadTypeId, this.documentThreads);
		});

		this.threadFilterForm?.get('threadFilterValue').valueChanges.subscribe(id => {
			this.documentThreads = this.documentThreadsCopy;
			const filterValue = this.threadSearchForm?.get('filterValues').value;

			this.filterByThreadType(id, this.documentThreads);
			this.filterThreads(filterValue, this.documentThreads);

		});

		this.threadForm.valueChanges.subscribe(res => {
			if (this.threadForm.dirty) {
				this.isUnsavedWork = true;
			}
		});

		this.supportOutForm.valueChanges.subscribe(res => {
			if (this.supportOutForm.dirty) {
				this.isUnsavedWork = true;
			}
		});

		this.additionalDocumentsForm.valueChanges.subscribe(res => {
			if (this.additionalDocumentsForm.dirty) {
				this.isUnsavedWork = true;
			}
		});

		this.completedFollowUpForm.valueChanges.subscribe(res => {
			if (this.completedFollowUpForm.dirty) {
				this.isUnsavedWork = true;
			}
		});

		this.jobDocumentFormGroup.valueChanges.subscribe(res => {
			if (this.jobDocumentFormGroup.dirty) {
				this.isUnsavedWork = true;
			}
		});

		this.addClassificationForm.valueChanges.subscribe(res => {
			if (this.addClassificationForm.dirty) {
				this.isUnsavedWork = true;
			}
		});

		this.addClassificationForm?.get('site').valueChanges.subscribe(site => {
			if (site) {
				this.getAddClassificationSiteAssets(site.accountSiteId);
			}
			this.addClassificationJob = null;
			this.addClassificationForm.patchValue({ asset: null });
			this.addClassificationForm.patchValue({ documentType: null });
		});

		this.addClassificationForm?.get('asset').valueChanges.subscribe(asset => {
			if (this.addClassificationForm.get('site')?.value?.accountSiteId && asset) {
				this.getClassificationDocumentTypes(this.addClassificationForm.get('site')?.value.accountSiteId, asset, this.addClassificationForm.get('site')?.value.serviceCategoryId, this.addClassificationForm.get('site')?.value.lineOfBusinessId);
			}
			this.addClassificationJob = null;
			this.addClassificationForm.patchValue({ documentType: null });
		});

		this.addClassificationForm?.get('documentType').valueChanges.subscribe(docType => {
			this.addClassificationDocumentClassAndTypeMappingId = docType?.id;
			if (this.addClassificationForm.get('site')?.value?.accountSiteId && this.addClassificationForm.get('asset')?.value && docType?.documentTypeId) {
				this.getAddClassificationJob(this.addClassificationForm.get('site').value.accountSiteId, this.addClassificationForm.get('asset').value, docType.documentTypeId, this.addClassificationForm.get('site')?.value.serviceCategoryId, this.addClassificationForm.get('site')?.value.lineOfBusinessId);
			}
			this.addClassificationJob = null;
		});

		this.addClassificationForm.get('documentConclusionOptionId').valueChanges.subscribe(id => {
			if (id) {
				this.additionalDocs.controls.map(item => item.get('isIncluded').setValue(false));
				const optionIndex = this.documentConclusionOptions.findIndex(x => x.documentConclusionOptionId === id);
				this.addClassificationForm.get('requiresAdditionalDocumentation').setValue(this.documentConclusionOptions[optionIndex].requiresAdditionalDocumentation);
				this.documentConclusionOptionSameGroupId = null;
			}
		});
	}

	private redirectToLogin(): void {
		sessionStorage.setItem('managed-docs-url', `${location.href}?presetEdit=true`);
		sessionStorage.setItem('managed-docs-info', JSON.stringify({ docId: this.documentId, docOid: this.oid }));
		this.authService.login();
	}

	ngAfterContentInit(): void {
		if (this.activatedRoute.snapshot.queryParamMap.get('presetEdit')) {
			setTimeout(() => {
				this.router.navigate([], { relativeTo: this.activatedRoute, replaceUrl: true });
				this.openManageDocumentModal();
			}, 200);
		}
	}

	get threadsDataSource(): MatTableDataSource<DocumentThread>{
		return new MatTableDataSource<DocumentThread>(this.documentThreads);
	}
	ngOnDestroy(): void {
		GlobalSettingsService.navigationBarActions = this.navigationBarActions;
	}

	public getAiEmailRecipients(isCopy: boolean): string {
		return this.managedJobDocuments.email.recipients.filter(r => r.isCopy === isCopy).map(r => r.email).join('; ');
	}

	public openManageDocumentModal(): void {
		this.isLoading = true;
		this.permissionDenied = false;
		this.isGuest = false;
		this.hasLoadingError = false;
		this.userAuthService.getManagedJobDocuments(this.documentId, this.oid)
			.subscribe((data: ManagedDocuments) => {
				this.managedJobDocuments = data;
				if (!data) {
					this.isGuest = true;
					this.permissionDenied = true;
				}
				else {
					if (data.cloudUserType.toLowerCase() === 'customer notify') {
						this.permissionDenied = true;
					}
					if(data.canManageFollowUps) {
						this.getThreadTypes();
						this.getDocumentThreads();
					}
				}
			}, (error: HttpErrorResponse) => {
				if (error.status === 401) {
					this.isGuest = true;
					this.permissionDenied = true;
				}
				else {
					this.hasLoadingError = true;
				}
				this.isLoading = false;
			}, () => {
				this.isLoading = false;
			});
		this.manageDocumentModal.open();
	}

	public get additionalDocs(): FormArray {
		// tslint:disable-next-line:no-string-literal
		return this.additionalDocumentsForm.get('additionalDocs') as FormArray;
	}

	public get selectedJobDocumentsCount(): number {
		return this.selectedJobDocuments?.length;
	}

	public get selectedJobDocuments(): any[] {
		return this.additionalDocs.controls.filter(x => x.get('isIncluded').value);
	}

	public isDocumentAI(): void {
		GlobalSettingsService.isSecondaryLoaderLoading = true;
		this.documentsService.isDocumentAi(this.documentId).subscribe(res => {
			this.isAIDocument = res;
		}, error => GlobalSettingsService.isSecondaryLoaderLoading = false,
			() => {
				this.injectActionButtons();
				GlobalSettingsService.isSecondaryLoaderLoading = false;
			});
	}

	public getDocument(isThumbnail: boolean): void {
		this.isDataLoading = true;
		if (!isThumbnail) {
			this.documentsService.aiDocumentInfo(this.documentId)
				.subscribe(aiDocInfo => {
					this.aiDocInfo = aiDocInfo;
					if (!!aiDocInfo && !!aiDocInfo.convertedDocumentId && !!aiDocInfo.convertedDocumentOid) {
						this.loadDocument(aiDocInfo.convertedDocumentId, aiDocInfo.convertedDocumentOid, false, aiDocInfo.documentName);
					}
					else {
						this.loadDocument(this.documentId, this.oid, false, null);
					}
				}, () => {
					console.error("Unable to load the AI Info for the current document!");
					this.loadDocument(this.documentId, this.oid, false, null);
				})
		}
		else {
			this.loadDocument(this.documentId, this.oid, true, null);
		}
	}

	public groupBinderTabs(binders: JobBinder[]): { binderTemplateName: string, tabs: { binderTabName: string }[] }[] {
		groupBy(binders, "binderTemplateName")

		const groupedBinderTemplates = [];
		Object.entries(groupBy(binders, x => [x.binderTemplateName]))
			.forEach((group) => {
				const binderTemplateName = group[0];
				const binderTabs = group[1] as JobBinder[];

				groupedBinderTemplates.push({
					binderTemplateName: binderTemplateName,
					tabs: binderTabs.map(binder => {
						return {
							binderTabName: binder.binderTabName
						};
					})
				});

			});
		return groupedBinderTemplates;
	}
	private loadDocument(documentId: number, documentOid: string, isThumbnail: boolean, overwriteDocDownloadName: string): void {
		this.documentsService.getDocumentByOid(documentOid, documentId, isThumbnail)
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					this.isDataLoading = false;
					return NEVER;
				})
			)
			.subscribe((response: HttpResponse<Blob>) => {
				let documentName = '';
				if (response.headers.has('content-disposition')) {
					const contentDispositionItems = response.headers.get('content-disposition').split(';');
					const fileNameItem = contentDispositionItems.find(i => i.trim().toLowerCase().startsWith('filename='));
					if (!!fileNameItem) {
						documentName = fileNameItem.replace(/"/g, '').trim().toLowerCase().replace('filename=', '');
					}
				}
				this.documentDetails = {
					documentId: documentId,
					content: response.body,
					fileName: documentName,
					documentDisplayName: documentName,
					documentDownloadName: overwriteDocDownloadName || documentName,
					isFitToPage: true
				};
				this.isDataLoading = false;
			});
	}

	public onDocTypeChange(docType: AddClassificationDocumentType): void {
		this.isLoading = true;
		this.onAddClassificationDocTypeChange(docType);
		this.documentsService.getConclusionGroup(this.selectedJobDocument.jobId, docType.id, this.managedJobDocuments?.sourceAccountId).subscribe(res => {
			this.documentConclusionOptions = res.options;
			this.jobDocumentFormGroup.patchValue({ documentConclusionOptionId: res.defaultOptionId });
			this.additionalDocs.controls.map(item => item.get('isIncluded').setValue(false));
			const optionIndex = this.documentConclusionOptions.findIndex(x => x.documentConclusionOptionId === res.defaultOptionId);
			this.jobDocumentFormGroup.get('requiresAdditionalDocumentation').setValue(this.documentConclusionOptions[optionIndex].requiresAdditionalDocumentation);
			this.documentConclusionOptionSameGroupId = null;
		}, error => {
			this.isLoading = false;
		}, () => this.isLoading = false);
	}

	public onAddClassificationDocTypeChange(docType: AddClassificationDocumentType): void {
		this.isManagedJobDocumentReviewRequired = docType.isReviewRequired;
	}

	private getConclusionGroups(jobId: number, jobDocument?: JobDocument, sourceAccountId?: number): void {
		this.documentsService.getConclusionGroup(jobId, jobDocument.documentClassAndTypeMappingId, sourceAccountId).subscribe(res => {
			this.documentConclusionOptions = res.options;
			const isSameGroup = this.documentConclusionOptions.map(x => x.documentConclusionOptionId).includes(jobDocument.documentConclusionOptionId);
			if (!isSameGroup) {
				this.documentConclusionOptionSameGroupId = jobDocument.documentConclusionOptionId;
				this.documentConclusionOptions.push({
					documentConclusionOptionId: jobDocument.documentConclusionOptionId,
					documentConclusionGroupId: res.documentConclusionGroupId,
					name: jobDocument.documentConclusionOption.concat('(conclusion group changed)', ' '),
					isSameGroup: true
				} as DocumentConclusionOption);
			}
		}, error => {
			ToastService.pushToast({
				text: 'Could not get Document Conclusion Groups. Please try again!',
				icon: 'error',
				type: ToastType.Error
			});
			this.isLoading = false;
		}, () => {
			this.isLoading = false;
		});
	}

	private injectActionButtons(): void {
		if (this.isAIDocument) {
			GlobalSettingsService.navigationBarActions.set(
				'manage_documents',
				{
					action: () => {
						if (!this.authService.isLoggedInWithVtrUserAccount()) {
							this.redirectToLogin();
						} else {
							this.openManageDocumentModal();
						}
					},
					text: 'Manage Documents',
					isInDropdownMenu: false,
					listOrder: 0
				});
		}
	}

	private initDocumentsForm(): void {
		this.jobDocumentFormGroup = new FormGroup({
			documentTypeName: new FormControl(null),
			effectiveDate: new FormControl(null),
			fileName: new FormControl(null),
			documentConclusionOptionId: new FormControl(null),
			isReviewed: new FormControl(false),
			requiresAdditionalDocumentation: new FormControl(false),
			documentClassAndTypeMappingId: new FormControl(null)
		});

		this.additionalDocumentsForm = new FormGroup({
			additionalDocs: new FormArray([])
		});

		this.filterDocumentsForm = new FormGroup({
			name: new FormControl(null),
			documentTypeId: new FormControl(0),
			effectiveDate: new FormControl(null)
		});
	}

	public getConclusion(id: number | null): string {
		return this.documentConclusionOptions.find(c => c.documentConclusionOptionId === id)?.name;
	}

	private loadJobDocumentForm(jobDocument: JobDocument): void {
		const index = this.classificationDocumentTypes.findIndex(x => x.documentTypeId === jobDocument.documentTypeId);
		this.jobDocumentFormGroup.patchValue({
			...jobDocument,
			documentClassAndTypeMappingId: this.classificationDocumentTypes[index]
		});
	}

	get isReviewed(): boolean {
		return this.jobDocumentFormGroup.get('isReviewed').value;
	}

	private loadJobDocuments(documents: JobDocument[]): void {
		documents?.forEach((doc) => {
			const isIncluded = this.jobDocument?.additionalDocIds?.includes(doc.jobDocumentId);
			const group = new FormGroup({
				isIncluded: new FormControl(isIncluded), // false
				jobDocumentId: new FormControl(doc.jobDocumentId),
				name: new FormControl(doc.fileName),
				effectiveDate: new FormControl(doc?.effectiveDate),
				documentTypeId: new FormControl(doc.documentClassAndTypeMappingId),
				documentTypeName: new FormControl(doc.documentTypeName)
			});

			if (this.selectedJobDocument?.canEdit || isIncluded || this.isOnAddClassification) {
				this.additionalDocs.push(
					group
				);
			}
		});
		this.additionalDocumentsCopy = cloneDeep(this.additionalDocs.controls);
	}

	public saveManagedDocument(): void {
		this.isLoading = true;
		const formData = this.jobDocumentFormGroup.getRawValue();
		const docUpdate = {} as DocumentUpdate;
		const optionIndex = this.documentConclusionOptions.findIndex(x => x.documentConclusionOptionId === formData.documentConclusionOptionId);

		docUpdate.effectiveDate = formData.effectiveDate;
		docUpdate.isReviewed = formData.isReviewed;
		docUpdate.documentConclusionOptionId = formData.documentConclusionOptionId;
		docUpdate.additionalJobDocIds = JSON.stringify(this.additionalDocs.getRawValue().filter(x => x.isIncluded).map(x => x.jobDocumentId));
		docUpdate.documentConclusionOption = this.documentConclusionOptions[optionIndex].name;
		docUpdate.requiresAdditionalDocumentation = this.documentConclusionOptions[optionIndex].requiresAdditionalDocumentation;
		docUpdate.documentTypeMappingId = formData.documentClassAndTypeMappingId.id;

		this.jobService.updateManagedJobDocument(this.selectedJobDocument.urlHash, this.oid, this.documentId, this.selectedJobDocument.jobDocumentId, docUpdate).subscribe(res => {
			this.userAuthService.getManagedJobDocuments(this.documentId, this.oid)
				.subscribe((data: ManagedDocuments) => {
					this.managedJobDocuments = data;
				});
			this.documentConclusionOptionSameGroupId = null;
			this.documentConclusionOptions = null;
			this.jobDocumentFormGroup.reset();
			this.filterDocumentsForm.reset();
			this.additionalDocs.clear();
			this.additionalDocumentsForm.reset();
			this.isUnsavedWork = false;
			this.showWarningMessage = false;
			this.isManagedJobDocumentReviewRequired = false;

			this.selectedJobDocument = null;
			this.isLoading = false;
		}, error => {
			ToastService.pushToast({
				text: 'Could not save Job Document. Please try again!',
				icon: 'error',
				type: ToastType.Error
			});
			this.showWarningMessage = false;
			this.isLoading = false;
		});
	}

	public onDrawerExpanded(): void {
		this.sidenav.open();
		this.showWarningMessage = false;
		this.isExtended = true;
	}

	public saveDocumentSelection(): void {
		this.sidenav.close();
		this.isExtended = false;
	}

	public onDocumentSelectionClose(): void {
		this.sidenav.close();
		this.showWarningMessage = false;
		this.isExtended = false;
	}

	public onDocOptionChange(id: number): void {
		this.additionalDocs.controls.map(item => item.get('isIncluded').setValue(false));
		const optionIndex = this.documentConclusionOptions.findIndex(x => x.documentConclusionOptionId === id);
		if (this.isOnAddClassification) {
			this.addClassificationForm.get('requiresAdditionalDocumentation').setValue(this.documentConclusionOptions[optionIndex].requiresAdditionalDocumentation);
		} else {
			this.jobDocumentFormGroup.get('requiresAdditionalDocumentation').setValue(this.documentConclusionOptions[optionIndex].requiresAdditionalDocumentation);
		}
		this.documentConclusionOptionSameGroupId = null;
	}

	public onAllDocumentsSelected(event: any): void {
		if (event.checked) {
			this.additionalDocs.controls.map(item => item.get('isIncluded').setValue(true));
			this.isUnsavedWork = true;
		} else {
			this.additionalDocs.controls.map(item => item.get('isIncluded').setValue(false));
			this.isUnsavedWork = true;
		}
	}

	public onCancelManageDocumentClick(): void {
		this.selectedTabIndex = 0;
		this.showWarningMessage = false;
		this.selectedJobDocument = null;
		this.documentConclusionOptionSameGroupId = null;
		this.documentConclusionOptions = null;
		this.jobDocumentFormGroup.reset();
		this.filterDocumentsForm.reset();
		this.threadSearchForm.patchValue({ filterValues: 3 });
		this.threadFilterForm.patchValue({threadFilterValue: 0});
		if (!!this.additionalDocs.controls) {
			this.additionalDocumentsForm.reset();
			this.additionalDocs?.clear();
		}
		this.addClassificationForm.reset();
		this.isOnAddClassification = false;
		this.isUnsavedWork = false;
		this.addClassificationForm.patchValue({ effectiveDate: new Date(), isReviewed: false });
		this.isManagedJobDocumentReviewRequired = false;
	}

	public getRequireAdditionalDocsMsg(additionalDocIdsCount: number): string {
		let requireAdditionalDocsMsg = '';
		if (additionalDocIdsCount === 0) {
			requireAdditionalDocsMsg = 'no additional doc(s)';
		}
		if (additionalDocIdsCount >= 1) {
			requireAdditionalDocsMsg = `${additionalDocIdsCount} additional doc(s)`;
		}

		return requireAdditionalDocsMsg;
	}

	public editManagedJobDocument(jobDocument: ManagedJobDocument): void {
		this.isLoading = true;
		this.selectedJobDocument = jobDocument;		
		this.getData(jobDocument);
	}

	private getData(jobDocument: ManagedJobDocument): void {
		forkJoin([
			//this.documentThreadService.getDocumentThreads(this.documentId),
			this.documentThreadService.getNotifyUsers(this.selectedJobDocument.urlHash, this.selectedJobDocument.jobDocumentId),
			this.jobService.getJobDocumentByJobDocumentId(jobDocument.urlHash, jobDocument.jobDocumentId),
			this.jobService.getJobDocuments(jobDocument.urlHash),
			this.lookupService.getDocumentTypes(jobDocument.urlHash),
			this.userAuthService.getUserDocumentTypes(this.selectedJobDocument.siteId, this.documentId, this.oid)
		])
			.subscribe(([/*documentThreads, */notifyUsers, jobDoc, jobDocuments, documentTypes, classificationDocumentTypes]) => {
				// // documentThreads
				// switch (this.threadSearchForm?.getRawValue()?.filterValues) {
				// 	case 1: this.documentThreads = documentThreads; break;
				// 	case 2: this.documentThreads = documentThreads.filter(x => x.isCompleted); break;
				// 	case 3: this.documentThreads = documentThreads.filter(x => !x.isCompleted); break;
				// 	default: this.documentThreads = documentThreads;
				// }
				// this.documentThreadsCopy = documentThreads;

				// notify users
				this.jobDocNotifyUsers = notifyUsers;

				// classification document types
				this.classificationDocumentTypes = classificationDocumentTypes;

				// job document
				this.jobDocument = jobDoc;
				this.loadJobDocumentForm(jobDoc);
				this.getConclusionGroups(jobDocument.jobId, jobDoc, this.managedJobDocuments?.sourceAccountId);

				// job documents
				this.jobDocuments = jobDocuments;
				this.loadJobDocuments(jobDocuments);

				// document types
				this.documentTypes = documentTypes;
				this.documentTypes.unshift({ id: 0, name: 'None' });


			}, error => {
				ToastService.pushToast({
					text: 'Could not get data. Please try again!',
					icon: 'error',
					type: ToastType.Error
				});
				this.isLoading = false;
			});
	}

	public onClose(): void {
		this.isLoading = true;
		this.resetWarningVariables();
		this.manageDocumentModal.hide();
		this.selectedJobDocument = null;
		this.documentConclusionOptionSameGroupId = null;
		this.documentConclusionOptions = null;
		this.isExtended = false;
		this.jobDocumentFormGroup.reset();
		this.additionalDocumentsForm.reset();
		this.filterDocumentsForm.reset();
		this.additionalDocs.clear();
		this.isLoading = false;
		this.selectedTabIndex = 0;
		this.threadForm.reset();
		this.threadForm.controls.followUpBy.clearValidators();
		this.threadSearchForm.patchValue({ filterValues: 3 });
		this.threadFilterForm.patchValue({threadFilterValue: 0});
		this.threadForm.patchValue({threadTypeId: 1});
		this.threadForm.controls.followUpBy.clearValidators();
		this.addClassificationForm.reset();
		this.isOnAddClassification = false;
		this.addClassificationForm.patchValue({ effectiveDate: new Date(), isReviewed: false });
		this.managedJobDocuments = null;
	}

	public onDateSearchClear(): void {
		this.filterDocumentsForm.get('effectiveDate').setValue(null);
		this.additionalDocs.controls = this.additionalDocumentsCopy;
		this.searchFilter(this.filterDocumentsForm.get('name')?.value?.toLowerCase(), DocumentFilterType.Name);
		this.searchFilter(this.filterDocumentsForm.get('documentTypeId')?.value, DocumentFilterType.DocumentType);
	}

	public tabChanged(tabChangeEvent: MatTabChangeEvent): void {
		this.selectedTabIndex = tabChangeEvent.index;
		if (!this.isUnsavedWork) {
			this.sidenav?.close();
			this.threadSidenav?.close();

			this.selectedThread = null;
			this.threadForm.reset();
			this.supportOutForm.reset();
		}
	}

	public searchFilter(searchValue: any, filterType: DocumentFilterType): void {
		if (searchValue && searchValue !== 0) {
			switch (filterType) {
				case DocumentFilterType.Name:
					this.additionalDocs.controls = this.additionalDocs.controls?.filter(x => (x.get('name').value)?.toLowerCase().includes(searchValue?.toLowerCase()));
					break;
				case DocumentFilterType.DocumentType:
					this.additionalDocs.controls = this.additionalDocs.controls.filter(x => x.get('documentTypeId')?.value === searchValue);
					break;
				case DocumentFilterType.EffectiveDate:
					this.additionalDocs.controls = this.additionalDocs.controls?.filter(x => (
						(moment(x.get('effectiveDate')?.value)).format('MM/DD/YYYY') === moment(searchValue).format('MM/DD/YYYY')));
					break;
			}
		} else {
			return;
		}
	}

	public filterByThreadType(threadType: number, threadList: DocumentThread[]): void {
		if (threadType > 0) {
			this.documentThreads = threadList.filter(x => x.threadTypeId === threadType);
		} 
	}

	public filterThreads(filterValue: number, threadList: DocumentThread[]): void {
		if (filterValue) {
			switch (filterValue) {
				case 1:
					break;
				case 2:
					this.documentThreads = threadList.filter(x => x.isCompleted);
					break;
				case 3:
					this.documentThreads = threadList.filter(x => !x.isCompleted);
					break;
			}
		} else {
			return;
		}
	}

	private initThreadForm(): void {
		this.threadForm = new FormGroup({
			documentThreadId: new FormControl(null),
			description: new FormControl(null, Validators.required),
			threadTypeId: new FormControl(1),
			threadTypeName: new FormControl(null),
			followUpBy: new FormControl(null),
			notifyUsers: new FormControl([]),
			completedComment: new FormControl(null)
		});
	}

	private initThreadSearchForm(): void {
		this.threadSearchForm = new FormGroup({
			filterValues: new FormControl(3)
		});

		this.threadFilterForm = new FormGroup({
			threadFilterValue: new FormControl(0)
		});
	}

	private initCompletionFollowUpForm(): void {
		this.completedFollowUpForm = new FormGroup({
			completedComment: new FormControl(null, Validators.required),
		});

	}

	private initSupportOutForm(): void {
		this.supportOutForm = new FormGroup({
			supportOutResponse: new FormControl(null),
			supportOutRequest: new FormControl(null, Validators.required)
		});
	}

	private loadThreadForm(documentThread: DocumentThread): void {
		this.threadForm.patchValue({
			documentThreadId: documentThread?.id,
			description: documentThread.description,
			threadTypeId: documentThread.threadTypeId,
			threadTypeName: documentThread.threadTypeName,
			followUpBy: documentThread?.followUpBy ? moment(documentThread.followUpBy).toDate() : null,
			notifyUsers: documentThread.notifyUsers,
			completedComment: documentThread?.completedComment
		});

		if (documentThread.isCompleted || documentThread.followUpTriggeredOn || documentThread.threadTypeId === ThreadType.SupportRequest) {
			this.threadForm.disable();
		} else {
			this.threadForm.enable();
		}

		if (documentThread.threadTypeId === 5) {
			this.supportOutForm.patchValue({
				supportOutResponse: documentThread?.completedComment,
				supportOutRequest: documentThread?.description
			});
			this.supportOutForm.get('supportOutRequest').disable();
			if (documentThread.isAcknowledged) {
				this.supportOutForm.get('supportOutResponse').disable();
			} else {
				this.supportOutForm.get('supportOutResponse').enable();
			}
		}
	}

	private loadNotifyUsers(documentThread: DocumentThread, users: NotifyUser[]): void {
		this.notifyUsers = orderBy(unionBy(documentThread?.notifyUsers ?? [], users, (a) => a.userAccountId), a => a.name);
	}

	public getDocumentThreads(): void {
		this.isLoading = true;
		this.documentThreadService.getDocumentThreads(this.documentId).subscribe(res => {
			switch (this.threadSearchForm?.getRawValue()?.filterValues) {
				case 1: this.documentThreads = res; break;
				case 2: this.documentThreads = res.filter(x => x.isCompleted); break;
				case 3: this.documentThreads = res.filter(x => !x.isCompleted); break;
				default: this.documentThreads = res;
			}

			this.filterByThreadType(this.threadFilterForm?.getRawValue()?.threadFilterValue, this.documentThreads);

			this.documentThreadsCopy = res;
			this.isLoading = false;
		}, error => {
			ToastService.pushToast({
				text: 'Could not get Document Threads. Please try again!',
				icon: 'error',
				type: ToastType.Error
			});
			this.isLoading = false;
		});
	}

	public addDocumentThread(): void {
		this.isLoading = true;
		const formData = this.threadForm.getRawValue() as DocumentThread;
		const documentThread = {} as DocumentThread;
		documentThread.description = formData.description;
		documentThread.followUpBy = formData?.followUpBy ? moment(formData?.followUpBy).format('MM/DD/YYYY') : null;
		documentThread.notifyUsers = formData.notifyUsers ?? [];
		documentThread.documentId = this.documentId;
		documentThread.threadTypeId = formData.threadTypeId;
		documentThread.threadTypeName = formData.threadTypeName;

		this.documentThreadService.addDocumentThread(documentThread).subscribe(res => {
			this.getDocumentThreads();
			this.selectedThread = null;
			this.threadForm.reset();
			this.threadForm.patchValue({threadTypeId: 1});
			this.threadForm.controls.followUpBy.clearValidators();
			this.resetWarningVariables();
			this.threadSidenav.close();
		}, error => {
			ToastService.pushToast({
				text: 'Could not add Document Thread. Please try again!',
				icon: 'error',
				type: ToastType.Error
			});
			this.isLoading = false;
			this.resetWarningVariables();
		});
	}

	public updateDocumentThread(): void {
		this.isLoading = true;
		const formData = this.threadForm.getRawValue();
		this.selectedThread.description = formData.description;
		this.selectedThread.followUpBy = formData?.followUpBy ? moment(formData?.followUpBy).format('MM/DD/YYYY') : null;
		this.selectedThread.notifyUsers = formData.notifyUsers ?? [];

		if (this.selectedThread.threadTypeId !== 5) {
			this.documentThreadService.updateDocumentThread(this.selectedThread).subscribe(res => {
				this.getDocumentThreads();
				this.selectedThread = null;
				this.threadForm.reset();
				this.threadForm.patchValue({threadTypeId: 1});
				this.threadForm.controls.followUpBy.clearValidators();
				this.resetWarningVariables();
				this.threadSidenav.close();
			}, error => {
				this.isLoading = false;
				ToastService.pushToast({
					text: 'Could not update this Document Thread. Please try again!',
					icon: 'error',
					type: ToastType.Error
				});
				this.resetWarningVariables();
				this.threadForm.reset();
				this.threadForm.controls.followUpBy.clearValidators();
				this.threadForm.patchValue({threadTypeId: 1});
			});
		} else {
			const supportOutData = this.supportOutForm.getRawValue();
			this.selectedThread.completedComment = supportOutData.supportOutResponse;
			this.documentThreadService.completeDocumentThread(this.selectedThread).subscribe(res => {
				this.getDocumentThreads();
				this.selectedThread = null;
				this.supportOutForm.reset();
				this.threadSidenav.close();
				this.resetWarningVariables();
			}, error => {
				ToastService.pushToast({
					text: 'Could not update this Document Thread. Please try again!',
					icon: 'error',
					type: ToastType.Error
				});
				this.selectedThread = null;
				this.isLoading = false;
				this.resetWarningVariables();
				this.supportOutForm.reset();
			});
		}

	}

	public resetWarningVariables(): void {
		this.isUnsavedWork = false;
		this.showWarningMessage = false;
		this.isSidenavOpen = false;
	}

	public completeDocumentFollowUp(): void {
		this.isLoading = true;
		const formData = this.completedFollowUpForm.getRawValue();
		this.selectedThread.completedComment = formData.completedComment;

		this.documentThreadService.completeDocumentThread(this.selectedThread).subscribe(res => {
			this.getDocumentThreads();
			this.selectedThread = null;
			this.threadForm.reset();
			this.threadForm.controls.followUpBy.clearValidators();
			this.threadForm.patchValue({threadTypeId: 1});
			this.completedFollowUpForm.reset();
			this.resetWarningVariables();
		}, error => {
			ToastService.pushToast({
				text: 'Could not update this Document Thread. Please try again!',
				icon: 'error',
				type: ToastType.Error
			});
			this.selectedThread = null;
			this.isLoading = false;
			this.resetWarningVariables();
			this.threadForm.reset();
			this.threadForm.controls.followUpBy.clearValidators();
			this.threadForm.patchValue({threadTypeId: 1});
			this.completedFollowUpForm.reset();
		});
	}

	public onEditThreadClick(thread: DocumentThread): void {
		this.selectedThread = thread;
		this.loadThreadForm(thread);
		if(thread.threadTypeId === ThreadType.FollowUp) {
			this.loadNotifyUsers(thread, this.jobDocNotifyUsers);
		}
		this.threadSidenav.open();
		this.isSidenavOpen = true;
	}

	public onThreadCancel(): void {
		this.threadSidenav.close();
		this.selectedThread = null;
		this.threadForm.reset();
		this.threadForm.controls.followUpBy.clearValidators();
		this.threadForm.patchValue({threadTypeId: 1});
		this.resetWarningVariables();
	}

	public onThreadSave(): void {
		this.selectedThread ? this.updateDocumentThread() : this.addDocumentThread();
	}

	public onThreadCompleteClick(): void {
		this.isOnCompleteFollowUp = true;
	}

	public onFollowUpComplete(): void {
		this.completeDocumentFollowUp();
		this.threadSidenav.close();
		this.isOnCompleteFollowUp = false;
	}

	public onFollowUpcompleteCancel(): void {
		this.isOnCompleteFollowUp = false;
		this.showWarningMessage = false;
		this.isSidenavOpen = false;
		this.completedFollowUpForm.reset();
	}

	public onAddThread(): void {
		this.notifyUsers = this.jobDocNotifyUsers;
		this.threadForm.enable();
		this.threadSidenav.open();
		this.isSidenavOpen = true;
	}

	public onTabClick(): void {
		this.showWarningMessage = true;
	}

	public deleteManagedJobDocument(jobDocument: ManagedJobDocument): void {
		this.deleteConfirmationModal.open();
		this.jobDocumentToDelete = jobDocument;
	}

	public onJobDocumentDeleteConfirmation(): void {
		this.isLoading = true;
		this.jobService.deleteManagedJobDocument(this.jobDocumentToDelete.urlHash, this.oid, this.documentId, this.jobDocumentToDelete.jobDocumentId).subscribe(res => {
			const index = this.managedJobDocuments.managedJobDocuments.findIndex(x => x.jobDocumentId === this.jobDocumentToDelete.jobDocumentId);
			this.managedJobDocuments.managedJobDocuments.splice(index, 1);
			this.isLoading = false;
		}, error => this.isLoading = false);
	}

	public onAddJobDocumentClick(): void {
		this.isOnAddClassification = true;
		if (!this.managedJobDocuments.sites.length) {
			const noSites = {} as AccountSiteInfo;
			noSites.accountSiteId = 0;
			noSites.name = 'No Data';
			this.addClassificationSites.push(noSites);
		} else {
			this.addClassificationSites = this.managedJobDocuments.sites;
		}
	}

	public initAddClassificationForm(): void {
		this.addClassificationForm = new FormGroup({
			documentType: new FormControl(null, Validators.required),
			site: new FormControl(null, Validators.required),
			asset: new FormControl(null, Validators.required),
			effectiveDate: new FormControl(new Date(), Validators.required),
			documentConclusionOptionId: new FormControl(null, Validators.required),
			isReviewed: new FormControl(false),
			requiresAdditionalDocumentation: new FormControl(false)
		});
	}

	public onAddClassificationClick(): void {
		this.isLoading = true;

		const formData = this.addClassificationForm.getRawValue();
		const classification = {} as AddJobDocument;

		classification.effectiveDate = formData.effectiveDate;
		classification.isReviewed = formData.isReviewed ?? false;
		classification.documentConclusionOptionId = formData.documentConclusionOptionId;
		classification.additionalJobDocIds = JSON.stringify(this.additionalDocs.getRawValue().filter(x => x.isIncluded).map(x => x.jobDocumentId));
		classification.documentId = this.documentId;
		classification.documentClassAndTypeMappingId = this.addClassificationDocumentClassAndTypeMappingId;
		classification.documentOid = this.oid;

		this.jobService.addJobDocument(this.addClassificationJob.urlHash, classification).subscribe(res => {
			this.userAuthService.getManagedJobDocuments(this.documentId, this.oid)
				.subscribe((data: ManagedDocuments) => {
					this.managedJobDocuments = data;
				});
			this.additionalDocumentsForm.reset();
			this.filterDocumentsForm.reset();
			this.addClassificationForm.reset();
			this.additionalDocs.clear();
			this.isLoading = false;
			this.isOnAddClassification = false;
			this.selectedTabIndex = 0;
			this.addClassificationDocumentClassAndTypeMappingId = null;
			this.addClassificationForm.patchValue({ effectiveDate: new Date(), isReviewed: false });
			this.isManagedJobDocumentReviewRequired = false;
			this.resetWarningVariables();
		}, error => {
			ToastService.pushToast({
				text: 'Could not add Job Document. Please try again!',
				icon: 'error',
				type: ToastType.Error
			});
			this.isUnsavedWork = false;
			this.showWarningMessage = false;
			this.isLoading = false;
		});

	}

	public getAddClassificationSiteAssets(accountSiteId: number): void {
		this.siteService.getSiteAssets(accountSiteId).subscribe(res => {
			this.addClassificationSiteAssets = [];
			if (!res.length) {
				const noAssets = {} as Item<number, string>;
				noAssets.id = 0;
				noAssets.name = 'No Data';
				this.addClassificationSiteAssets.push(noAssets);
			} else {
				this.addClassificationSiteAssets = res;
			}
		});
	}

	public getClassificationDocumentTypes(accountSiteId: number, accountSiteResourceId: number, serviceCategoryId?: number, lineOfBusinessId?: number): void {
		this.userAuthService.getUserDocumentTypes(accountSiteId, this.documentId, this.oid, accountSiteResourceId, serviceCategoryId, lineOfBusinessId).subscribe(res => {
			this.classificationDocumentTypes = [];
			if (!res.length) {
				const noDocType = {} as AddClassificationDocumentType;
				noDocType.id = 0;
				noDocType.documentTypeId = 0;
				noDocType.name = 'No Data';
				this.classificationDocumentTypes.push(noDocType);
			} else {
				this.classificationDocumentTypes = res;
			}
		});
	}

	public getAddClassificationJob(accountSiteId: number, accountSiteResourceId: number, documentTypeId: number, serviceCategoryId?: number, lineOfBusinessId?: number): void {
		this.isLoading = true;
		this.userAuthService.getAddClassificationJob(accountSiteId, accountSiteResourceId, documentTypeId, serviceCategoryId, lineOfBusinessId).subscribe(res => {
			this.addClassificationJob = res[0];
		}, error => this.isLoading = false
			, () => {
				if (this.addClassificationJob) {
					this.documentsService.getConclusionGroup(this.addClassificationJob.id, this.addClassificationDocumentClassAndTypeMappingId, this.managedJobDocuments?.sourceAccountId).subscribe(res => {
						this.documentConclusionOptions = res.options;
						this.addClassificationForm.patchValue({ documentConclusionOptionId: res.defaultOptionId });
					}, error => {
						this.isLoading = false;
					}, () => this.isLoading = false);
					this.getJobDocuments(this.addClassificationJob.urlHash);
					this.getDocumentTypes(this.addClassificationJob.urlHash);
				} else {
					this.isLoading = false;
				}
			});
	}

	public getJobDocuments(urlHash: string): void {
		this.jobService.getJobDocuments(this.addClassificationJob.urlHash).subscribe(res => {
			this.jobDocuments = res;
		}, error => this.isLoading = false,
			() => {
				this.loadJobDocuments(this.jobDocuments);
			});
	}

	public getDocumentTypes(urlHash: string): void {
		this.lookupService.getDocumentTypes(urlHash).subscribe(res => {
			this.documentTypes = res;
		}, error => this.isLoading = false);
	}

	private checkDownloadButtonDisableStatus(): void {
		if (this.downloadButton) {
			if (!this.disableDownloadDocButton) {
				this.downloadButton.style.color = '#121FDF';
				this.downloadButton.style.cursor = 'pointer';
				this.downloadButton.disabled = false;
			} else {
				this.downloadButton.style.color = '#e2e2e2';
				this.downloadButton.style.cursor = 'not-allowed';
				this.downloadButton.disabled = true;
			}
		}
	}

	public setHeaderElements(header) {
		this.docViewerHeaderReady = false;
		const items: any[] = header.getItems();

		this.customButtons = [
			{
				type: 'customElement',
				dataElement: 'customDownloadDocButton',
				render: () => {
					const downloadButton = document.createElement('button');
					downloadButton.innerHTML = 'Download';

					downloadButton.style.fontSize = '18px';
					downloadButton.style.fontWeight = '700';
					downloadButton.style.fontFamily = 'Segoe UI';
					downloadButton.style.border = 'none';
					downloadButton.style.background = 'transparent';
					downloadButton.style.padding = '0 10px';
					downloadButton.style.textDecoration = 'underline';
					downloadButton.style.color = '#e2e2e2';
					downloadButton.style.cursor = 'not-allowed';
					downloadButton.disabled = true;

					downloadButton.onclick = () => {
						this.downloadCurrentDocument();
					};

					this.downloadButton = downloadButton;
					return downloadButton;
				},
			},
		];
		
		const toolbarItems = [...this.customButtons, ...items];		
		header.update(toolbarItems);
		this.docViewerHeaderReady = true;
	}

	public downloadCurrentDocument(): void {
		this.documentsService.getDownloadDocument(this.oid, this.documentId)
			.subscribe((blob) => {
				saveAs(blob, this.documentDetails.documentDownloadName);
			});
	}

	public afterWebViewerRender(instance): void {
		if (!this.isThumbnail) {
			instance.setHeaderItems((header) => {

				this.setHeaderElements(header);

			});

			const interval = setInterval(() => {
				if (!this.docViewerHeaderReady) return;
				this.checkDownloadButtonDisableStatus();
				this.cdRef.detectChanges();
				clearInterval(interval);
			}, 100);
		}
	}

	public onThreadTypeChange(threadType: MatSelectChange): void {
		switch (threadType.value) {
			case ThreadType.Note: {
				this.threadForm.controls.followUpBy.clearValidators();
				this.threadForm.patchValue({followUpBy: null});
				break;
			}
			case ThreadType.FollowUp: {
				this.threadForm.controls.followUpBy.setValidators(Validators.required);
				break;
			}

			case ThreadType.SupportRequest: {
				this.threadForm.controls.followUpBy.clearValidators();
				this.threadForm.patchValue({followUpBy: null});
				break;
			}
		}
	}

	public getThreadTypes(): void {
		this.documentThreadService.getDocumentThreadTypes().subscribe(res => {
			this.threadTypes = res;
		});
	}
}
